<template>
    <el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
				单笔结算申请
			</el-col>
			<el-col :xs="24" :md="18">
				<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
					<el-form-item>
						<el-button v-if="$hasPermission('plat:plattask:update')" type="primary" @click="approvalSubmit(1)">批量结算</el-button>
					</el-form-item>
					<el-form-item>
						<el-button v-if="$hasPermission('plat:platapply:export')"  type="primary" @click="exportHandle()">{{ $t('export') }}</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="info" @click="getDataList()">刷新</el-button>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
        <div class="mod-plat__plattask}">
            <el-form  style="padding:10px 5px 0px;" ref="loginFormRef" :model="dataForm" @keyup.enter.native="getDataList()">
				<el-row>
					<el-col :md="12" :lg="6">
						<el-form-item label-width="110px" label="结算主体名称" prop="dealCode"><el-input style="width: 100%;" v-model="dataForm.dealBody" placeholder="结算主体名称" clearable></el-input></el-form-item>
					</el-col>
					
					<el-col :md="12" :lg="6">
						<el-form-item label-width="150px" label="合同编号" prop="dealCode"><el-input style="width: 100%;" v-model="dataForm.contractCode" placeholder="合同编号" clearable></el-input></el-form-item>
					</el-col>
					<el-col :md="12" :lg="6">
						<el-form-item  label-width="110px" label="任务编号:" prop="status">
							<el-autocomplete v-model="dataForm.taskCode" :fetch-suggestions="querySearchAsync" placeholder="任务编号"></el-autocomplete>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="6">
						<el-form-item label-width="0px" style="margin-left:10px">
							<div >
								<el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
								<el-button type="info" @click="resetLoginForm">重置</el-button>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
            <el-table v-loading="dataListLoading" :data="dataList"
                      @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
                <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                <el-table-column label="序号" type="index" width="50" align="center">
                    <template slot-scope="scope">
                        <span>{{(page - 1) * limit + scope.$index + 1}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="taskCode" label="任务发布编号" header-align="center" align="center">
					<template slot-scope="scope">
						<el-button style="word-break: break-all;white-space: wrap;" type="text" size="small" @click="taskinfoHandle(scope.row.taskId)">{{scope.row.taskCode}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="acceptTaskCode" label="任务接受编号" header-align="center" align="center">
					<template slot-scope="scope">
						<el-button style="word-break: break-all;white-space: wrap;" type="text" size="small" @click="taskinfoHandle(scope.row.taskId)">{{scope.row.acceptTaskCode}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="taskType" label="任务大类" header-align="center" align="center" width="120">
                    <template slot-scope="scope">
                        {{ $getDictLabel("taskType", scope.row.taskType) }}
                    </template>
                </el-table-column>
				<el-table-column prop="money" label="预算金额(元)" header-align="center" align="center"></el-table-column>
                <el-table-column prop="publishName" label="发布方" header-align="center" align="center"></el-table-column>
				<el-table-column prop="realName" label="接收方" header-align="center" align="center"></el-table-column>
				<el-table-column prop="phone" label="手机号" header-align="center" align="center"></el-table-column>
				<el-table-column prop="idCard" label="证件号" header-align="center" align="center"></el-table-column>
				<el-table-column prop="bankNo" label="收款账号" header-align="center" align="center"></el-table-column>
				<el-table-column prop="bankName" label="开户行" header-align="center" align="center"></el-table-column>
				<el-table-column prop="unitPrice" label="单价" header-align="center" align="center">
					<template slot-scope="scope">
						<div v-if="scope.row.unitPriceEdit" style="height:40px;line-height: 40px;" @click="priceTextClick(scope.row,'unitPriceEdit','unitPrice')">{{showTwoPoint(scope.row.unitPrice)}}</div>
						<el-input :disabled="scope.row.dealStatus == 1" v-if="!scope.row.unitPriceEdit" style="width: 100%;" v-model="scope.row.unitPrice" placeholder="请输入单价" clearable @blur="itemPriceChange('unitPrice',scope.row)" v-focus></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="quantity" label="数量" header-align="center" align="center">
					<template slot-scope="scope">
						<div v-if="scope.row.quantityEdit" style="height:40px;line-height: 40px;" @click="priceTextClick(scope.row,'quantityEdit','quantity')">{{showTwoPoint(scope.row.quantity)}}</div>
						<el-input :disabled="scope.row.dealStatus == 1" v-if="!scope.row.quantityEdit" style="width: 100%;" v-model="scope.row.quantity" placeholder="请输入数量" clearable @blur="itemPriceChange('quantity',scope.row)"  v-focus></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="dealMoney" label="金额" header-align="center" align="center">
					<template slot-scope="scope">
						<div v-if="scope.row.dealMoneyEdit" style="height:40px;line-height: 40px;" @click="priceTextClick(scope.row,'dealMoneyEdit','dealMoney')">{{showTwoPoint(scope.row.dealMoney)}}</div>
						<el-input :disabled="scope.row.dealStatus == 1" v-if="!scope.row.dealMoneyEdit" style="width: 100%;" v-model="scope.row.dealMoney" placeholder="请输入金额" clearable @blur="itemPriceChange('dealMoney',scope.row)" v-focus></el-input>
					</template>
				</el-table-column>
                <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="200">
                    <template slot-scope="scope">
						<el-button v-if="scope.row.dealStatus == 0" type="text" size="small"
						           @click="approvalSubmit(2,scope.row)">提交结算
						</el-button>
						<span v-else>已结算</span>
						<br />
						<span
							v-if="scope.row.dealStatus != 0"
							style="color: #3a7dd1; cursor: pointer; line-height: 15px"
							class="home_link_hover"
							@click="downloadVoucher(scope.row.approvalId, 1)"
							>下载商户上线及任务发布信息表</span
						><br />
						<span
							v-if="scope.row.dealStatus != 0"
							style="color: #3a7dd1; cursor: pointer; line-height: 15px"
							class="home_link_hover"
							@click="downloadVoucher(scope.row.approvalId, 2)"
							>下载业务确认及服务成果验收单</span
						><br />
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
			background
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="limit"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="pageSizeChangeHandle"
                    @current-change="pageCurrentChangeHandle">
            </el-pagination>
            <!-- 弹窗, 新增 / 修改 -->
            <plat-apply-approval v-if="platApplyApprovalVisible" ref="platApplyApproval"
                           @refreshDataList="getDataList"></plat-apply-approval>
        </div>
    </el-card>
</template>

<script>
import Cookies from "js-cookie";
import mixinViewModule from '@/mixins/view-module'
import PlatApplyApproval from './platapply-approval'
import { addDynamicRoute } from '@/router'

export default {
	directives: {
		focus: {
			inserted: function (el) {
				el.querySelector('input').focus()
			}
		}
	},
	mixins: [mixinViewModule],
	data() {
		return {
			platApplyApprovalVisible: false,
			mixinViewModuleOptions: {
				getDataListURL: '/sys/plat/apply/page',
				getDataListIsPage: true,
				deleteURL: '/sys/plat/task',
				deleteIsBatch: true,
				exportURL: '/sys/plat/apply/export',
				// createdIsNeed:false,
			},
			dataForm: {
				dealBody:"",
				contractCode: '',
				taskCode: ''
			},
			taskCodeList:[], //任务编号模糊搜索
			
		}
	},
	components: {
		PlatApplyApproval
	},
	// activated(){
	//     this.dataForm = this.$store.state.listForm ? this.$store.state.listForm : this.dataForm
	// 	this.$nextTick(() => {
	// 		this.query();
	// 	})
	// 	return false;
	// },
	methods: {
 		//下载商户上线及任务发布信息表
		downloadVoucher(id, num) {
			if (num == 1) {
				//下载商户上线及任务发布信息表
				window.open(
				`${
					window.SITE_CONFIG["apiURL"]
				}/sys/plat/deal/approval/downloadBusinessTask?id=${id}&access_token=${Cookies.get(
					"access_token"
				)}`
				);
			} else if (num == 2) {
				//下载业务确认及服务成果验收单
				window.open(
				`${
					window.SITE_CONFIG["apiURL"]
				}/sys/plat/deal/approval/downloadTaskResult?id=${id}&access_token=${Cookies.get(
					"access_token"
				)}`
				);
			}
			// window.open(`${window.SITE_CONFIG['apiURL']}/sys/plat/deal/approval/downloadCompletionCert?id=${id}&access_token=${Cookies.get('access_token')}`)
			},
		platApplyApprovalHandle (taskCode){
			this.platApplyApprovalVisible = true
			this.$nextTick(() => {
				this.$refs.platApplyApproval.init(taskCode)
			})
		},
		approvalSubmit(type,row){
			if(type == 1){ //如果是批量审核且无选择信息
				if(!this.dataListSelections.length){
					this.$message({
						message: '请选择批量审核的信息！',
						type: 'error',
						duration: 500,
					})
					return
				}
			}
			this.$confirm(this.$t('prompt.info', { 'handle': '提交结算'}), this.$t('prompt.title'), {
				confirmButtonText: this.$t('confirm'),
				cancelButtonText: this.$t('cancel'),
				type: 'warning'
			}).then(()=>{
				let params;
				if(type == 2){
					params = [row]
				}else{
					params = this.dataListSelections
				}
				let flag = true;
				params.forEach(element => {
					element.unitPrice = element.unitPrice!=undefined?element.unitPrice:'';
					element.quantity = element.quantity!=undefined?Number(element.quantity):'';
					element.dealMoney = element.dealMoney!=undefined?element.dealMoney:'';
					if(element.unitPrice<=0 || element.quantity<=0 || element.dealMoney<=0){
						flag = false
						return
					}
				});
				if(!flag){
					this.$message({
						message: '请检查所提交申请数据完整性，单击表格进行编辑！',
						type: 'error',
					})
					return
				}else{
					let resultParams = params.map(item=>{
						return {
							userId:item.userId,
							realName:item.realName,
							phone:item.phone,
							idCard:item.idCard,
							bankNo:item.bankNo,
							bankName:item.bankName,
							dealMoney:item.dealMoney,
							unitPrice:item.unitPrice,
							quantity:item.quantity,
							taskId:item.taskId,
							taskAcceptId:item.id,
						}
					})
					this.$http.post('/sys/plat/deal/approval/submit',resultParams).then(({ data: res })=>{
						if (res.code !== 0) {
							return this.$message.error(res.msg)
						}
						this.$message({
							message: this.$t('prompt.success'),
							type: 'success',
							duration: 500,
							onClose: () => {
								this.getDataList()
							}
						})
					}).catch(()=>{})
				}
				
			}).catch(()=>{})
		},
		querySearchAsync(queryString, cb) {
			if(queryString){
				this.$http.post('/sys/plat/apply/search',{taskCode:queryString}).then(({data:res})=>{
					if (res.code !== 0) {
						return this.$message.error(res.msg)
					}
					cb(res.data.map(item=>{
						return {value:item}
					}))
				})
			}else{
				cb([])
			}
		},
		taskinfoHandle(id) {
			// this.$store.commit('listForm', this.dataForm)
			localStorage.setItem(this.$route.name,JSON.stringify(this.dataForm))
			const routeParams = {
				routeName: `${this.$route.name}__任务详情`,
				title: `任务详情`,
				path: 'plat/platttask-info',
				params: {
					id:id
				}
			}
			// 动态路由
			addDynamicRoute(routeParams, this.$router)
		},
		
		
		itemPriceChange(type,row){    // 计算规则

			if(row.unitPrice!=undefined||row.quantity!=undefined||row.dealMoney!=undefined){
				let numReg6= /(^[1-9](\d+)?(\.\d{1,6})?$)|(^\d\.\d{1,6}$)/; //大于0的6位小数
				let numRegZs = /^\+?[1-9]\d*$/;
				row.unitPrice = row.unitPrice!=undefined?row.unitPrice:'';
				row.quantity = row.quantity!=undefined?row.quantity:'';
				row.dealMoney = row.dealMoney!=undefined?row.dealMoney:'';
				if(type == 'unitPrice'){  //输入情况为单价
					if(!numReg6.test(row.unitPrice)){ //是否是大于0最多为六位小数
						row.unitPrice = ''
						this.$message({
							type:'error',
							message:'输入的数必须是大于0的正数且最多保留六位小数',
						})
						return false;
					}else {
						if(numReg6.test(row.quantity)){ //数量有值算金额
							row.dealMoney = parseFloat((row.unitPrice*row.quantity).toFixed(6));
						}else if(numReg6.test(row.dealMoney)){ //金额有数 数量没数算数量
							row.quantity = parseFloat((row.dealMoney/row.unitPrice).toFixed(6));
						}
						this.$set(row,'unitPriceEdit',true);
					}
				}else if(type == 'quantity'){
					if(!numRegZs.test(row.quantity)){
						row.quantity = ''
						this.$message({
							type:'error',
							message:'输入的数必须是大于0的正数',
						})
						return false;
					}else{
						if(numReg6.test(row.unitPrice)){ //单价有值算金额
							row.dealMoney = parseFloat((row.unitPrice*row.quantity).toFixed(6));	
						}else if(numReg6.test(row.dealMoney)){ //金额有数 单价没数算单价
							row.unitPrice = parseFloat((row.dealMoney/row.quantity).toFixed(6));	
						}
						this.$set(row,'quantityEdit',true);
					}
				}else if(type == 'dealMoney'){
					if(!numReg6.test(row.dealMoney)){ //是否是大于0最多为两位小数
						row.dealMoney = ''
						this.$message({
							type:'error',
							message:'输入的数必须是大于0的正数且最多保留六位小数',
						})
						return false;
					}else {
						if(numReg6.test(row.quantity)){ // 数量有值算单价
							console.log(row.quantity,numReg6.test(row.quantity))
							row.unitPrice = parseFloat((row.dealMoney/row.quantity).toFixed(6));	
						}else if(numReg6.test(row.unitPrice)){ //单价有数 数量没数算数量
							console.log(row.dealMoney,numReg6.test(row.dealMoney))
							row.quantity = parseFloat((row.dealMoney/row.unitPrice).toFixed(6));	
						}
						this.$set(row,'dealMoneyEdit',true);
					}
				}
			}
			

		},
		priceTextClick(row,edit,key){
			this.$set(row,edit,false);
			if(row[key] == undefined){
				this.$set(row,key,'');
			}
		},
		showTwoPoint(val){
			return typeof(val-0) == 'number'&& (val-0)>0 ? (val-0).toFixed(2):'';
		},
		resetLoginForm(){
			this.dataForm.dealBody = "";
			this.dataForm.contractCode = "";
			this.dataForm.taskCode = "";
			this.getDataList();
		},
	}
}
</script>
